import React from "react";
import dunceImg from "../assets/images/webp/what-is-dunce.webp";
import Paragraph from "./custom-ui/Paragraph";
import PrimaryHeading from "./custom-ui/PrimaryHeading";

function WhatDunce() {
  return (
    <div
      id="about-dunce"
      className="2xl:max-w-[1560px] xl:max-w-[1240px] relative z-30 mx-auto lg:px-5 md:px-8 px-5 container 2xl:py-[100px] lg:pt-10 lg:pb-16 md:pb-12 sm:pb-10 sm:pt-6 mt-20 xl:mt-0"
    >
      <div className="bg-dark-purple rounded-28 border-4 border-royal-blue overflow-hidden">
        <div className="flex md:gap-16 gap-12 2xl:gap-[65px] lg:flex-row flex-col items-center px-5 bg-dark-purple lg:py-[66px] sm:py-[58px] py-12 max-w-[1310px] mx-auto">
          {/* Image Container */}
          <div className="flex justify-start items-center">
            <div className="bg-pink-bg border-4 relative border-dark-purple md:rounded-28 rounded-2xl md:p-3 p-2 2xl:w-[597px] xl:w-[550px] max-w-[700px] 2xl:h-[442px] xl:h-[400px] transition-all duration-300 ease-in-out 2xl:shadow-xlPurpleShadow xl:shadow-lgPurpleShadow shadow-mdPurpleShadow hover:shadow-none hover:translate-x-2 hover:translate-y-2">
              <img
                src={dunceImg}
                alt="what-is-dunce-img"
                className="md:rounded-28 rounded-2xl w-full 2xl:h-[404px] xl:h-full md:h-[550px] object-cover"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="w-full xl:max-w-[830px] custom-1200:max-w-[560px] lg:max-w-[460px]">
            {/* Primary Heading */}
            <PrimaryHeading
              className="lg:text-start text-white text-center"
              children="What is $Dunce"
            />

            {/* First Paragraph */}
            <Paragraph
              className="xl:pt-12 sm:pt-7 !lg:text-custom-30 sm:text-xl md:text-2xl text-lg text-white lg:text-start text-center pt-4 max-w-[800px] "
              children="Inspired by the iconic dunce cap, our mascot Duncan embodies the daring spirit of crypto enthusiasts who thrive on the market's twists and turns."
            />

            {/* Second Paragraph */}
            <Paragraph
              className="xl:pt-12 sm:pt-7 text-white !lg:text-custom-30 sm:text-xl md:text-2xl text-lg lg:text-start text-center pt-4"
              children="Dunce Coin isn’t just a digital asset; it’s a community-driven token that embraces the bold and unpredictable nature of the crypto world."
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatDunce;
